/* eslint-disable */
// @ts-nocheck

// Scripts used for comments modules.
// This script is extracted from frontend-scripts to be used in Divi's Dynamic Assets system.
(function ($) {
  window.et_pb_form_placeholders_init = function ($form) {
    // Init each form/module separately so Show Labels cannot leak across Comments modules.
    $form.each(function () {
      const $current_form = $(this);
      const $comments_module = $current_form.closest('.et_pb_comments_module');
      const show_labels = $comments_module.hasClass('et_pb_contact_show_labels');
      const $fields = $current_form.find('input:text, input[type="email"], input[type="url"], textarea');

      $fields.each((index, domEle) => {
        const $et_current_input = jQuery(domEle);
        const $et_comment_label = $et_current_input.siblings('label');
        let et_comment_label_value = $et_current_input.siblings('label').text();
        if ($et_comment_label.length) {
          if (show_labels) {
            $et_comment_label.show();
            if ($et_current_input.siblings('span.required').length) {
              et_comment_label_value += $et_current_input.siblings('span.required').text();
              $et_current_input.siblings('span.required').show();
            }
            if (et_comment_label_value === $et_current_input.val()) {
              $et_current_input.val('');
            }
            $et_current_input.attr('placeholder', et_comment_label_value);
            return;
          }
          $et_comment_label.hide();
          if ($et_current_input.siblings('span.required')) {
            et_comment_label_value += $et_current_input.siblings('span.required').text();
            $et_current_input.siblings('span.required').hide();
          }
          $et_current_input.removeAttr('placeholder');
          $et_current_input.val(et_comment_label_value);
        }
      });

      // Visual Builder re-runs this helper when Show Labels toggles. Unbind first so leftover
      // labels-off focus/blur handlers cannot write placeholder text back into empty fields.
      $fields.off('focus.et_pb_placeholders blur.et_pb_placeholders');

      if (show_labels) {
        return;
      }

      $fields
        .on('focus.et_pb_placeholders', function () {
          let et_label_text = jQuery(this).siblings('label').text();
          if (jQuery(this).siblings('span.required').length)
            et_label_text += jQuery(this).siblings('span.required').text();
          if (jQuery(this).val() === et_label_text) jQuery(this).val('');
        })
        .on('blur.et_pb_placeholders', function () {
          let et_label_text = jQuery(this).siblings('label').text();
          if (jQuery(this).siblings('span.required').length)
            et_label_text += jQuery(this).siblings('span.required').text();
          if ('' === jQuery(this).val()) jQuery(this).val(et_label_text);
        });
    });
  };

  $(window).on('et_pb_init_modules', function () {
    window.et_pb_init_comments_modules = function () {
      // Document Ready
      $(() => {
        window.et_pb_comments_init = function ($comments_module) {
          const $comments_module_button = $comments_module.find('.comment-reply-link, .submit');

          if ($comments_module_button.length) {
            $comments_module_button.addClass('et_pb_button');

            if (
              typeof $comments_module.attr('data-icon') !== 'undefined' &&
              $comments_module.attr('data-icon') !== ''
            ) {
              $comments_module_button.attr('data-icon', $comments_module.attr('data-icon'));
              $comments_module_button.addClass('et_pb_custom_button_icon');
            }

            if (
              typeof $comments_module.attr('data-icon-tablet') !== 'undefined' &&
              $comments_module.attr('data-icon-tablet') !== ''
            ) {
              $comments_module_button.attr('data-icon-tablet', $comments_module.attr('data-icon-tablet'));
              $comments_module_button.addClass('et_pb_custom_button_icon');
            }

            if (
              typeof $comments_module.attr('data-icon-phone') !== 'undefined' &&
              $comments_module.attr('data-icon-phone') !== ''
            ) {
              $comments_module_button.attr('data-icon-phone', $comments_module.attr('data-icon-phone'));
              $comments_module_button.addClass('et_pb_custom_button_icon');
            }
          }
        };

        // apply required classes for the Reply buttons in Comments Module
        if ($('.et_pb_comments_module').length) {
          $('.et_pb_comments_module').each(function () {
            const $comments_module = $(this);

            et_pb_comments_init($comments_module);
            et_pb_form_placeholders_init($comments_module.find('#commentform'));
          });
        }

        // Add submit handler to clear placeholder text
        $('.et_pb_comments_module #commentform').on('submit', function () {
          window.et_pb_remove_placeholder_text($(this));
        });
      });
    };

    window.et_pb_init_comments_modules();
  });
})(jQuery);
